















import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Auth } from "@/mixins/auth";
import { Roles } from "@/models/user/roles";
import AuthService from "@/services/auth_service";
import Header from "@/components/header/Header.vue";
import Sidebar from "@/components/sidebar/Menu.vue";
import CartModal from "@/components/elements/modal/CartModal.vue";
import { EventBus } from "./event-bus";
import { Mobile } from "@/mixins/mobile";
import { LineItem } from "./models/order/order";
import { User } from "./models/user/user";
import { OrderMixin } from "./mixins/orders/mixin";

@Component({
  components: {
    Header,
    Sidebar,
    CartModal
  }
})
export default class App extends mixins(Auth, Mobile, OrderMixin) {
  protected environment = process.env.VUE_APP_ENV;
  protected envBuildBranch = process.env.VUE_APP_BUILD_BRANCH;
  protected envBuildDate = process.env.VUE_APP_BUILD_DATE;
  protected Roles = Roles;
  protected authService = new AuthService();
  protected showModal = false;
  protected cartInfo: {
    qty?: number;
    model: string;
    productline?: string;
    name?: string;
    finish?: string;
    fabric?: string;
    cost?: number;
    quickshipList?: LineItem[];
    accessoryList?: LineItem[];
    sku?: string;
  } | null = null;

  created() {
    if (this.environment === 'development') {
      console.log(
        `Logged Dev App Build Details: Branch - ${
          this.envBuildBranch ? this.envBuildBranch : "N/A"
        } | Date - ${this.envBuildDate ? this.envBuildDate : "N/A"}`
      );
    }
    this.checkAuth();
    EventBus.$on(
      "addToCartModal",
      (cartInfo: {
        qty?: number;
        model: string;
        productline?: string;
        name?: string;
        finish?: string;
        fabric?: string;
        options?: object;
        cost?: number;
        quickshipList?: LineItem[];
        accessoryList?: LineItem[];
        sku?: string;
      }) => {
        this.showModal = true;
        this.cartInfo = cartInfo;
      }
    );

    this.handleView();
    window.addEventListener("resize", this.handleView);
  }

  protected handleView() {
    this.setMobile(window.innerWidth <= 640);
    this.setTablet(window.innerWidth < 960 && window.innerWidth > 640);
  }

  // protected closeModal(): void {
  //   this.showModal = false;
  //   this.editItem();
  // }

  protected viewCart(): void {
    this.showModal = false;
    this.$router.push("/cart");
  }

  protected async checkAuth(): Promise<void> {
    try {
      const user: any = await this.authService.checkAuth();
      if (user.role === Roles.Unverified || user.role === Roles.RetailerLevel1 || user.role === Roles.Removed) {
        this.setLoggedIn(false);
        this.setUserRole(null);
        this.setUserInfo({} as User);
        await this.authService.logout();
        this.$router.push("/error");
      } else {
        this.setLoggedIn(true);
        this.setUserInfo(user);
        this.setUserRole(user.role);
      }
    } catch (err) {
      this.setLoggedIn(false);
      this.setUserRole(null);
      this.setUserInfo({} as User);
      this.$router.push("/login");
    }
  }

  beforeDestroy(): void {
    EventBus.$off("addToCartModal");
  }
}
